module.exports = __webpack_public_path__ + "img/3_ai_rect.4f3053cd.png";